import { render, staticRenderFns } from "./ListLiquidations.vue?vue&type=template&id=c977ab1a"
import script from "./ListLiquidations.vue?vue&type=script&lang=js"
export * from "./ListLiquidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports